import { gql } from "@apollo/client";

export default gql`
  fragment RelatedAssessmentSubmission on AssessmentSubmissionNode {
    type
    status
    delivery {
      id
      canUpdate {
        permission
      }
    }
    completeCount
    pendingCount
    users {
      id
      name
      avatar
    }
    template {
      id
      anonymity
      delivery
      assessmentType
      assessments(targetId: $targetId, state: submitted) {
        edges {
          node {
            id
            canUpdate {
              permission
            }
            target {
              id
            }
            responder {
              id
              name
            }
          }
        }
      }
    }
    canCalibrate {
      permission
    }
  }
  query getReviewSubmissions($complianceProgramId: Int!, $targetId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      assessmentSubmissions(targetId: $targetId) {
        ...RelatedAssessmentSubmission
      }
    }
  }
`;
